// @flow
export type ErrorLog = { type: 'ERROR_LOG_EVENT', error: Error, auxData?: Object };

export default function errorLog(error: Error, auxData?: Object): ErrorLog {
  return {
    type: 'ERROR_LOG_EVENT',
    error,
    auxData,
  };
}
